import '../css/main.scss';
import SiteUI from './modules/SiteUI.js'
import generateJoke from "./modules/GenerateJoke.js";

const ui = new SiteUI();

ui.show();

console.log("Welcome to McIntyre Chat");

console.log("Here's a joke for you: " + generateJoke());